import { auditChangeFields } from "../../api/mcp";
import { Reason } from "../write/ReasonText";

/**
 * One audit row's before → after as a small key/value diff.
 *
 * Shared by Recent changes, Labeeb history, and the full audit log.
 */
export function AuditChangeDetail({
  before,
  after,
  action,
  reason,
  compact = false,
}: {
  before: unknown;
  after: unknown;
  action?: string | null;
  reason?: string | null;
  /** Smaller type for footnotes (Recent changes). */
  compact?: boolean;
}) {
  const fields = auditChangeFields(before, after, action);
  const text = compact ? "text-xs" : "text-sm";

  return (
    <div className={text}>
      {fields.length > 0 && (
        <dl
          className={`mt-1 grid gap-1 ${compact ? "text-xs" : "text-sm"}`}
          style={{ gridTemplateColumns: "minmax(6rem, auto) 1fr 1fr" }}
        >
          <div className="contents font-medium text-slate-400 dark:text-slate-500">
            <dt className="sr-only">Field</dt>
            <dd className="text-[10px] tracking-wide uppercase">Before</dd>
            <dd className="text-[10px] tracking-wide uppercase">After</dd>
          </div>
          {fields.map((row) => (
            <div key={row.key} className="contents">
              <dt className="ref break-words pr-2 text-slate-500 dark:text-slate-400">{row.key}</dt>
              <dd className="break-words text-slate-500 dark:text-slate-400">{row.before}</dd>
              <dd className="break-words text-slate-950 dark:text-white">{row.after}</dd>
            </div>
          ))}
        </dl>
      )}
      {reason && (
        <p className="mt-1.5 text-xs text-slate-500 dark:text-slate-400">
          <Reason text={reason} />
        </p>
      )}
    </div>
  );
}
